import { FC, useState } from 'react';

import { Box, Typography } from '@mui/material';

import { IPromotion } from 'api/website';

import useScreen from 'hooks/useScreen';
import useSelectedTheme from 'store/theme';

import PromotionDetailsDialog from './PromotionDetails';
import sx from './styles';

interface PromotionCardProps {
  m?: number;
  my?: number;
  promotion: IPromotion;
  width?: number | string;
  height?: number | string;
}

const PromotionCard: FC<PromotionCardProps> = ({ width, height, m, my, promotion }) => {
  const { isMobile } = useScreen();
  const [{ isDark }] = useSelectedTheme();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {isOpen && <PromotionDetailsDialog open promotion={promotion} onClose={() => setIsOpen(false)} />}
      <Box
        sx={sx.root({
          m,
          my,
          width,
          height,
          image: isDark
            ? promotion.thumbnail_img_dark || promotion.thumbnail_img
            : promotion.thumbnail_img || promotion.thumbnail_img_dark,
        })}
        onClick={() => setIsOpen(true)}
        data-testid="promotion-thumbnail"
      >
        <Box sx={sx.overlay({ isMobile })}>
          <Typography fontSize={isMobile ? 12 : 14} data-testid="promotion-title">
            {promotion.title}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default PromotionCard;
